import Enumerator from './Enumerator';

export const creditRecordOptions = ['none', 'good', 'bad', 'unsure'];

export class CreditRecordOption extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: number) {
    let correctOption = option;
    switch (option) {
      case 0:
        correctOption = 'none';
        break;
      case 1:
        correctOption = 'good';
        break;
      case 2:
        correctOption = 'bad';
        break;
      case 3:
        correctOption = 'unsure';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

CreditRecordOption.initEnum({
  none: {
    get title() {
      return 'No selection made';
    }
  },
  good: {
    get title() {
      return 'Good (applicant is certain their credit record is good)';
    }
  },
  bad: {
    get title() {
      return 'Bad (applicant has known credit issues)';
    }
  },
  unsure: {
    get title() {
      return 'Unsure (applicant does not know)';
    }
  }
});

export default {
  creditRecordOptions,
  CreditRecordOption
};
